/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { serialNum } from "../../../utils";
import urls from "../../../api/urls";
import API from "../../../api";
import "./style.scss";
const OutScanBag = () => {
  const { GET_ALL_BAGS } = urls;
  const [allBagaes, setAllBagages] = useState();
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "Sl No",
      align: "center",
      with: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Bag ID / AWB No",
      dataIndex: "bagBarcodeNo",
      key: "bagBarcodeNo",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Destination",
      dataIndex: "destinationName",
      key: "destinationName",
      render: (text) => (
        <div>
          {text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase()}
        </div>
      ),
    },
    {
      title: "Bag Colour",
      dataIndex: "bagColor",
      key: "bagColor",
      render: (text, _record) => (
        <div>
          {_record?.mode == "fast track" || _record?.mode == "value plus"
            ? "Green"
            : _record?.contentType == "DOX"
            ? "Blue"
            : _record?.travelBy == "air"
            ? "Yellow"
            : "White"}
        </div>
      ),
    },
    {
      title: "Bag Weight(Kg)",
      dataIndex: "weight",
      key: "weight",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "No of Shipments",
      dataIndex: "bagContents",
      key: "bagContents",
      render: (text) => <div>{text?.length || "------"}</div>,
    },
    {
      title: "Date & Time",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (text) => <div>{text?.replaceAll(" ", "/")}</div>,
    },
  ];
  useEffect(() => {
    getAllBags();
  }, []);
  
  const getAllBags = async () => {
    setLoading(true);
    let response = await API.Api(GET_ALL_BAGS).getWithUserNPremiseHeader();
    if (response?.response?.status == 200) {
      let filteredData = response?.response?.data?.filter(
        (data) => data?.status == "FINALISED" || data?.status == "SORTED"
      );
      setAllBagages(filteredData);
      setLoading(false);
    }
  };

  return (
    <div className=" bagging-shipment">
      <div className="lcr-table-container">
        <Table loading={loading} columns={columns} dataSource={allBagaes} />
      </div>
    </div>
  );
};

export default OutScanBag;
